import { AttributesMixin, define, Model } from "@type-r/models";

export interface Metadata extends AttributesMixin<typeof Metadata> { }

@define
export class Metadata extends Model {
  static attributes = {
    dateFormat: String
  };
}
